import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import closeModal from 'Helpers/ModalHelper';
import useCollection from 'Hooks/useCollection';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { makeStyles } from '@material-ui/core';
import MetaCollectionFormDialog from 'Components/UI/Meta/MetaForm/MetaCollectionFormDialog';
import relationships from 'Consts/Relationships';
import { GoalOverride, GoalOverrideClientGoalsPageAndBanner } from 'Resources/Goal';

import {
  displayErrorMessage,
  displaySuccess,
} from 'Helpers/FacetNotificationManager';
import featureEnabled from 'Helpers/Affordances';

const useStyles = makeStyles(theme => ({
  dialogPaper: {
    width: theme.dimensions.lg,
  },
}));

function GoalModal({ goalId }) {
  const { collection, setCollection } = useCollection();
  const { householdResource } = useSimpleHousehold();
  const classes = useStyles();

  const handleClose = () => {
    closeModal();
  };

  useEffect(() => {
    if (
      householdResource
      && householdResource.relationship(relationships.goals)
      && householdResource.relationship(relationships.goals).link('related')
    ) {
      householdResource
        .relationship(relationships.goals)
        .link('related')
        .Get({
          metaOverrideSet: featureEnabled(householdResource, relationships.goalsPageAndBanner) ? GoalOverrideClientGoalsPageAndBanner : GoalOverride,
          params: goalId ? { id: goalId } : { limit: 0, offset: 0 },
        })
        .then((coll) => {
          if (coll.resources().length() === 0) {
            coll.create({
              addToCollection: true,
              metaOverrideSet: featureEnabled(householdResource, relationships.goalsPageAndBanner) ? GoalOverrideClientGoalsPageAndBanner : GoalOverride,
            });
          }
          setCollection(coll);
        })
        .catch((err) => {
          displayErrorMessage(err, err.errors);
        });
    }
  }, [householdResource]);

  const onSuccess = () => {
    displaySuccess('Goal Saved');
    handleClose();
  };

  const onFailure = (err) => {
    displayErrorMessage(err, err.errors);
  };

  if (!collection) return null;

  let rows = [
    ['type'],
    ['description'],
    ['amount'],
    ['timeHorizonValue', 'timeHorizonType'],
    ['priority'],
    ['status'],
    ['notes'],
  ];

  if (featureEnabled(householdResource, relationships.goalsPageAndBanner)) {
    rows = [[]];
  }
  return (
    <MetaCollectionFormDialog
      classes={{
        dialogPaper: classes.dialogPaper,
      }}
      collection={collection}
      onClose={handleClose}
      onFailure={onFailure}
      onSubmit={onSuccess}
      rows={rows}
      title={goalId ? 'Edit Goal' : 'Add Goal'}
    />
  );
}

GoalModal.defaultProps = {
  goalId: null,
};

GoalModal.propTypes = {
  goalId: PropTypes.string,
};

export default GoalModal;
